'use client'

import Icon from "@/components/etc/icon";
import React, { useEffect, useState } from "react";

export interface FloatDialogProps extends React.HTMLAttributes<HTMLDivElement> {
    show: boolean,
    backdropHide?: boolean
    setShow: Function,
    onHide?: Function,
}

const Head: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ ...rest }) => <div className={`fd-head`} {...rest}></div>;
const Body: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ ...rest }) => <div className={`fd-body`} {...rest}></div>;

const BaseFloatDialog = React.forwardRef<HTMLDivElement, FloatDialogProps>(
    ({ show, setShow, onHide, backdropHide=true, className, children, ...rest }, ref) => {
        const [control, setControl] = useState<boolean>(false)

        useEffect(()=>{
            if(show){
                document.documentElement.style.overflow = 'hidden'
                setControl(true)
            }else{
                const dialoglength = document.getElementsByClassName('float-dialog')
                if(dialoglength.length == 1){
                    // 마지막 팝업 닫을 시 스크롤 복구
                    document.documentElement.style.overflow = 'auto'
                }
                if(onHide){
                    onHide()
                }
                setTimeout(()=> setControl(false), 100)
            }
        }, [show])

        if(!control) return null;

        return (
            <div ref={ref} className={`float-dialog ${className}`} {...rest} >
                <div className="float-backdrop" onClick={e=> backdropHide && setShow(false)}></div>
                {/* <div className="float-backdrop" ></div> */}
                <div className={`fd-content ${show ? "active" : "deactive"}`}>
                    <Icon icon={`close`} onClick={e=> setShow(false)} className="close-btn" />
                    <main>{children}</main>
                </div>
            </div>
        );
    }
);

BaseFloatDialog.displayName = "FloatDialog";

type FloatDialogComponent = React.ForwardRefExoticComponent<
  FloatDialogProps & React.RefAttributes<HTMLDivElement>
> & {
  Head: typeof Head;
  Body: typeof Body;
};

const FloatDialog = BaseFloatDialog as FloatDialogComponent;
FloatDialog.Head = Head;
FloatDialog.Body = Body;


export default FloatDialog;